import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { ToastContainer } from "react-toastify";
import UserReducer from "./store/user/reducers/UserReducer";
import VenueReducer from "./store/Venue/reducers/VenueReducer";
import PersonsReducer from "./store/person/reducers/PersonsReducer";
import TeamReducer from "./store/team/reducers/TeamReducer";
import TournamentReducer from "./store/tournament/reducers/TournamentReducer";
import './index.css'
import SportReducer from "./store/sport/reducers/sportReducer";
import DivisionReducer from "./store/division/reducers/divisionReducer";
import { rosterReducer } from "./store/roster/reducers/rosterReducer";
import alertReducer from "./store/alert/reducers/alertReducer";
import BracketReducer from "./store/bracket/reducers/bracketReducer";
import draftReducer from "./store/draft/reducer/reducer";
import filtersReducer from "./store/filters/filtersReducer";
import dashboardReducer from "./store/dashboard/dashboardReducer";

// 🔇 Disable ////console.logs in production
/*if (process.env.REACT_APP_ENV === 'development') {
  ////console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep console.error and console.warn for debugging critical issues
}*/


const rootReducer = combineReducers({
  user: UserReducer,
  venue: VenueReducer,
  person: PersonsReducer,
  team: TeamReducer,
  tournament: TournamentReducer,
  sport: SportReducer,        
  division: DivisionReducer,  
  roster: rosterReducer,  
  alert: alertReducer,
  bracket: BracketReducer,  
  draft: draftReducer, // ← ADD THIS LINE
  filters: filtersReducer,     // global sport filter (persisted)
  dashboard: dashboardReducer, // admin dashboard summary (not persisted)
});

const { persistStore, persistReducer } = require("redux-persist");



let devtools, store;
const isClient = typeof window !== "undefined";
if (isClient) {
  devtools = window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : (f) => f;

  const storage = require("redux-persist/lib/storage").default;

 /*   // CLEAR THE PERSISTED STATE (ONE TIME FIX)
  storage.removeItem('persist:usmlsa').then(() => {
    ////console.log("✅ Cleared persisted state");
  });*/

  const persistConfig = {
    key: "usmlsa",
    storage,
    blacklist: ['team', 'roster', 'draft', 'dashboard']  // Don't persist team and roster
  };

  store = createStore(

    persistReducer(persistConfig, rootReducer),
    compose(applyMiddleware(thunk), devtools)
  );


  store.__PERSISTOR = persistStore(store);
} else {
  store = (rootReducer, compose(applyMiddleware(thunk)));
}



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
    <ToastContainer />
  </React.StrictMode>
);
